import React from 'react';
import { CLIENTS } from '../../../data/credibility.mjs';
import './FEClients.css';

// Misma fuente que el slider de la portada: src/data/credibility.mjs (sólo clientes con permission: true).
const partners = CLIENTS.filter((c) => c.permission).map((c) => ({ src: c.logo, alt: c.name }));

const FEClients = () => {
    if (partners.length === 0) return null;
    return (
        <section id="fe-clients" className="fe-clients">
            <div className="container">
                <div className="row justify-content-center mb-4">
                    <div className="col-12 text-center">
                        <p className="fe-clients__heading">
                            Empresas que confían en nosotros
                        </p>
                    </div>
                </div>

                <div className="row justify-content-center align-items-center">
                    {partners.map((partner, index) => (
                        <div key={index} className="col-6 col-sm-6 col-md-3 mb-4 d-flex justify-content-center">
                            <div className="fe-clients__logo-wrap">
                                <img
                                    src={partner.src}
                                    alt={partner.alt}
                                    className="fe-clients__logo"
                                />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FEClients;
